export function luhnValid(num: string): boolean {
  const digits = num.replace(/\D/g, '');
  if (digits.length < 12 || digits.length > 19) return false;
  let sum = 0;
  let dbl = false;
  for (let i = digits.length - 1; i >= 0; i--) {
    let d = Number(digits[i]);
    if (dbl) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    dbl = !dbl;
  }
  return sum % 10 === 0;
}

export function expiryValid(mmYY: string, now = new Date()): boolean {
  const m = /^(\d{2})\s*\/\s*(\d{2})$/.exec(mmYY.trim());
  if (!m) return false;
  const month = Number(m[1]);
  const year = 2000 + Number(m[2]);
  if (month < 1 || month > 12) return false;
  const end = new Date(year, month, 0, 23, 59, 59);
  return end >= now;
}

const BRAND_BY_FIRST_DIGIT: Record<string, string> = {
  '3': 'amex',
  '4': 'visa',
  '5': 'mastercard',
  '6': 'discover',
};

/** The card network a number belongs to, by its first digit (mock mode only). */
export function cardBrand(num: string): string {
  return BRAND_BY_FIRST_DIGIT[num.replace(/\D/g, '').charAt(0)] ?? 'visa';
}

/**
 * The mock payment method id for a card the host typed: last four, brand and expiry, so the mock
 * provider reports the card that was entered (J19). Expects a number and expiry already validated.
 */
export function mockPaymentMethodId(num: string, mmYY: string): string {
  const digits = num.replace(/\D/g, '');
  const [mm = '', yy = ''] = mmYY.split('/').map((part) => part.trim());
  return `mock_pm_${digits.slice(-4)}_${cardBrand(digits)}_${mm.padStart(2, '0')}_${yy.padStart(2, '0')}`;
}
